// extracted by mini-css-extract-plugin
export default {"item":"SectionItem_item__b6jk+"};